export default {
  ARROW_DOWN: 40,
  ARROW_UP: 38,
  ENTER: 13,
  ESCAPE: 27,
  SPACEBAR: 32,
  TAB: 9
};